export const GOODWAY_WHITE = '#F2F2F2';
export const GOODWAY_YELLOW = '#FCD119';
export const GOODWAY_RED = '#fc3319';
export const GOODWAY_LIGHT = '#272B49';
export const GOODWAY_DARK = '#1a1d30';
export const GOODWAY_SAND_400 = '#919191';
